<template>
  <div class="legal-page">
    <h1>Cookie政策</h1>
    <p><strong>最后更新日期：【2026】年【3】月【14】日</strong></p>

    <p>
      本Cookie政策解释了【LiAng】（“本网站”、“我们”）在您访问本网站时如何使用Cookie和类似追踪技术。本政策旨在帮助您了解这些技术是什么、我们为什么使用它们，以及您控制其使用的权利[citation:4][citation:6]。
    </p>

    <h2>1. 什么是Cookie？</h2>
    <p>
      Cookie是您访问网站时，网站放置在您设备（电脑、平板或手机）上的小型文本文件。Cookie被广泛用于使网站更高效地工作，并向网站所有者提供信息。Cookie通常包含一个唯一的标识符，这使得网站能够在您返回时“记住”您的设备[citation:4]。
    </p>

    <h2>2. 我们如何使用Cookie</h2>
    <p>我们使用Cookie和类似技术（如网络信标、像素标签）来[citation:4][citation:6]：</p>
    <ul>
      <li><strong>必要Cookies：</strong>使您能够浏览本网站并使用其基本功能，如访问网站的安全区域。这些Cookies是网站正常运行所必需的。</li>
      <li>
        <strong>分析/性能Cookies：</strong>帮助我们了解访问者如何与我们的网站互动，例如统计独立访客数量、页面访问频率、用户在页面上停留时间等。这些信息用于改进我们网站的功能和用户体验。我们可能使用第三方分析服务（如Google
        Analytics）来收集和分析此类信息[citation:4]。</li>
      <li><strong>功能性Cookies：</strong>用于在您再次访问时识别您，以便我们为您提供个性化的内容，例如记住您的语言偏好。</li>
      <li><strong>目标/广告Cookies：</strong>（如果您的网站未来投放广告）这些Cookie用于记录您对本网站的访问、您访问过的页面以及您点击的链接，以便向您展示您可能更感兴趣的广告。</li>
    </ul>

    <h2>3. 我们使用的具体Cookie</h2>
    <p>下表列出我们可能在本网站上使用的一些特定Cookie及其用途[citation:4]：</p>
    <table border="1" cellpadding="5" style="border-collapse: collapse; width: 100%;">
      <thead>
        <tr>
          <th>Cookie名称</th>
          <th>提供方</th>
          <th>类型/用途</th>
          <th>有效期</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>_ga</td>
          <td>Google Analytics</td>
          <td>用于区分用户。与分析功能相关。</td>
          <td>2年</td>
        </tr>
        <tr>
          <td>_gid</td>
          <td>Google Analytics</td>
          <td>用于区分用户。与分析功能相关。</td>
          <td>24小时</td>
        </tr>
        <tr>
          <td>_gat_UA-XXXXXXXX-X</td>
          <td>Google Analytics</td>
          <td>用于限制请求速率。与分析功能相关。</td>
          <td>1分钟</td>
        </tr>
        <tr>
          <td>[您可能使用的其他Cookie]</td>
          <td>[提供方]</td>
          <td>[用途说明]</td>
          <td>[有效期]</td>
        </tr>
      </tbody>
    </table>
    <p><em>注：上述列表可能不完整，我们建议您定期查看此政策。第三方Cookie的具体信息，请访问相应第三方的隐私政策[citation:4]。</em></p>

    <h2>4. 如何控制Cookie</h2>
    <p>当您首次访问本网站时，我们会向您显示一个Cookie横幅，请求您同意我们在您的设备上放置非必要的Cookie。您可以通过该横幅的“设置”或类似选项，选择接受或拒绝不同类别的Cookie[citation:6]。</p>
    <p>您也可以通过浏览器设置来管理和控制Cookie。大多数浏览器允许您[citation:4]：</p>
    <ul>
      <li>查看您拥有的Cookie，并在需要时单独删除它们；</li>
      <li>阻止第三方Cookie；</li>
      <li>阻止来自特定网站的Cookie；</li>
      <li>阻止所有Cookie的设置；</li>
      <li>在关闭浏览器时清除所有Cookie。</li>
    </ul>
    <p>请注意，如果您选择通过浏览器设置拒绝或禁用Cookie，本网站的某些功能可能无法正常运行，您的网站体验可能会受到影响[citation:4]。</p>
    <p>如果您想禁用Google Analytics的跟踪，您可以安装<a href="https://tools.google.com/dlpage/gaoptout" target="_blank">Google
        Analytics Opt-out Browser Add-on</a>[citation:4]。</p>

    <h2>5. 本政策的变更</h2>
    <p>我们可能会不时更新本Cookie政策，以反映我们使用的Cookie的变化，或出于其他运营、法律或监管原因。任何变更将在本页面上发布，并附上更新的“最后更新日期”[citation:2]。</p>

    <h2>6. 联系我们</h2>
    <p>如果您对本Cookie政策有任何疑问，请通过以下方式联系我们：</p>
    <p>电子邮件：【1051966401@qq.com】</p>
  </div>
</template>